function Loading() {
    return (
        <div className="spinner-border text-danger" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    );
}

// Bouton de soumission des formulaires : désactivé avec spinner pendant l'enregistrement, pour éviter un double envoi.
export function BoutonEnregistrer({ isSaving, isDisabled = false }) {
    return (
        <button type="submit" className="btn-axian-cramoisie" disabled={isSaving || isDisabled}>
            {isSaving && <span className="spinner-border spinner-border-sm btn-icon-mr" aria-hidden="true"></span>}
            {isSaving ? 'Enregistrement…' : 'Enregistrer'}
        </button>
    );
}

export default Loading;